import { render } from "./EditCard.vue?vue&type=template&id=5e898a8d"
import script from "./EditCard.vue?vue&type=script&lang=js"
export * from "./EditCard.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./EditCard.vue?vue&type=style&index=0&id=5e898a8d&lang=scss&module=true"
cssModules["$style"] = style0
import "./EditCard.vue?vue&type=style&index=1&id=5e898a8d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__